import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import styled from "styled-components";

import { SyncOutlined } from "@ant-design/icons";

import { Skeleton, Typography } from "antd";

import {
  CmtSyncRunStartedAt,
  CmtSyncRunStatusTag,
} from "@app/components/settings/CmtSyncRunDetails.tsx";
import { useSyncActions } from "@app/services/hook/useSyncActions.tsx";
import { colors } from "@app/theme.ts";

const StyledBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.875rem;
  padding: 0.75rem 1rem;
  border: 1px solid ${colors.border};
  border-radius: 14px;
  background: ${colors.white};
`;

const StyledIcon = styled.div`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: ${colors["pink-light"]};
  color: ${colors.pink};
  font-size: 1.1rem;
`;

const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.35;
  font-size: 0.875rem;
`;

export const CmtLastErpSync = () => {
  const { syncActions, isLoading } = useSyncActions();
  const erp = syncActions.find((status) => status.action === "SYNC_ERP");
  const lastRun = erp?.lastRun;

  return (
    <StyledBanner>
      <StyledIcon>
        <SyncOutlined spin={erp?.running} />
      </StyledIcon>
      {isLoading ? (
        <Skeleton.Input active size="small" />
      ) : (
        <StyledText>
          <Typography.Text type="secondary" style={{ fontSize: "0.75rem" }}>
            <FormattedMessage
              id="users.last_erp_sync"
              defaultMessage="Last ERP synchronisation"
            />
          </Typography.Text>
          <span>
            {lastRun ? (
              <>
                <Typography.Text strong>
                  <CmtSyncRunStartedAt run={lastRun} />
                </Typography.Text>{" "}
                <CmtSyncRunStatusTag status={lastRun.status} />
              </>
            ) : (
              <Typography.Text strong>
                <FormattedMessage
                  id="settings.never_run"
                  defaultMessage="Never run yet"
                />
              </Typography.Text>
            )}
          </span>
          {lastRun?.status === "FAILURE" && (
            <Typography.Text type="secondary" style={{ fontSize: "0.75rem" }}>
              <FormattedMessage
                id="settings.last_success"
                defaultMessage="Last success:"
              />{" "}
              {erp?.lastSuccess ? (
                <CmtSyncRunStartedAt run={erp.lastSuccess} />
              ) : (
                <FormattedMessage id="settings.never" defaultMessage="never" />
              )}
            </Typography.Text>
          )}
        </StyledText>
      )}
      <Link to="/settings" style={{ marginLeft: "0.5rem", fontWeight: 600 }}>
        <FormattedMessage id="users.manage_sync" defaultMessage="Manage" />
      </Link>
    </StyledBanner>
  );
};
